import { render, staticRenderFns } from "./Summary_Multimedias.vue?vue&type=template&id=aa88a2e6&scoped=true&"
import script from "./Summary_Multimedias.vue?vue&type=script&lang=js&"
export * from "./Summary_Multimedias.vue?vue&type=script&lang=js&"
import style0 from "./Summary_Multimedias.vue?vue&type=style&index=0&id=aa88a2e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa88a2e6",
  null
  
)

export default component.exports